import React, { useEffect, useState, useMemo, useRef } from 'react';
import NativeSelect from '@material-ui/core/NativeSelect';
import Box from '@material-ui/core/Box';

export type ComboBoxItemTypeSOD = {
  key: string;
  name: string;
};

type Props = {
  itemList: ComboBoxItemTypeSOD[] | undefined;
  label: string;
  value?: string;
  itemBoxStyle?: string;
  spanStyle?: string;
  labelStyle?: string;
  onChangeEvent?: (event: { name?: string; value: unknown }) => void;
};

export const ItemComboBoxStrOD: React.FC<Props> = (props) => {
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [val, setVal] = useState<string>(props.value ?? '');
  const inputEl = useRef<HTMLSelectElement>(null);

  const innerChange = (value: string) => {
    setVal(value);
  };

  useEffect(() => {
    if (isEdit) {
      inputEl.current?.focus();
    }
  }, [isEdit]);

  return (
    <Box display="flex" justifyContent="flex-start" alignItems="center">
      <div className={props.labelStyle ?? ''}>{props.label}</div>
      <div>
        {isEdit ? (
          <select
            ref={inputEl}
            onChange={(e) => innerChange(e.target.value)}
            className={props.itemBoxStyle ?? ''}
            value={val}
            onBlur={() => {
              if (props.onChangeEvent) {
                props.onChangeEvent({ value: val });
              }
              setIsEdit(false);
            }}
          >
            {props.itemList?.map((row, index) => (
              <option key={index} value={row.key}>{`${row.name}`}</option>
            ))}
          </select>
        ) : (
          <span
            className={props.spanStyle ?? 'MuiInput-underline'}
            onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
              setIsEdit(true);
            }}
          >
            {props.itemList?.find((row) => row.key == props.value)?.name}
          </span>
        )}
      </div>
    </Box>
  );
};
export default ItemComboBoxStrOD;
